module.exports = __webpack_public_path__ + "static/media/saba-icon.128707e0.webp";